/*
 * shopit-api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.41
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The CorrelationJson model module.
 * @module model/CorrelationJson
 * @version v1
 */
export class CorrelationJson {
  /**
   * Constructs a new <code>CorrelationJson</code>.
   * @alias module:model/CorrelationJson
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>CorrelationJson</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/CorrelationJson} obj Optional instance to populate.
   * @return {module:model/CorrelationJson} The populated <code>CorrelationJson</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new CorrelationJson();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('name'))
        obj.name = ApiClient.convertToType(data['name'], 'String');
      if (data.hasOwnProperty('position'))
        obj.position = ApiClient.convertToType(data['position'], 'String');
      if (data.hasOwnProperty('relation_id'))
        obj.relation_id = ApiClient.convertToType(data['relation_id'], 'String');
      if (data.hasOwnProperty('relation_name'))
        obj.relation_name = ApiClient.convertToType(data['relation_name'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} id
 */
CorrelationJson.prototype.id = undefined;

/**
 * @member {String} name
 */
CorrelationJson.prototype.name = undefined;

/**
 * @member {String} position
 */
CorrelationJson.prototype.position = undefined;

/**
 * @member {String} relation_id
 */
CorrelationJson.prototype.relation_id = undefined;

/**
 * @member {String} relation_name
 */
CorrelationJson.prototype.relation_name = undefined;

